import { render, staticRenderFns } from "./PrevisionList.vue?vue&type=template&id=2ca287a0&lang=pug&"
import script from "./PrevisionList.vue?vue&type=script&lang=js&"
export * from "./PrevisionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PrevisionList.vue"
export default component.exports